{% block sw_sales_channel_detail_content_tabs %}
    <template v-if="!isAgenticCommerceType">
        {% parent %}
    </template>
{% endblock %}

